export interface ParsedWorkbenchPathRoute {
  scope: 'root' | 'project' | 'context'
  view: 'workspace' | 'ledger'
  projectId: string
  workId: string
  contextId: string
}

export interface BuildWorkbenchPathInput {
  projectId: string
  workId?: string
  contextId?: string
}

export interface BuildWorkbenchLedgerPathInput {
  projectId: string
  workId?: string
  contextId: string
}

export function buildWorkbenchPath(projectId: string, contextId: string, workId?: string): string
export function buildWorkbenchPath(input: BuildWorkbenchPathInput): string
export function buildWorkbenchPath(
  inputOrProjectId: string | BuildWorkbenchPathInput,
  maybeContextId?: string,
  maybeWorkId?: string
): string {
  if (typeof inputOrProjectId === 'string') {
    const projectId = inputOrProjectId
    const contextId = maybeContextId || ''
    const workId = maybeWorkId

    if (!contextId) {
      return `/workbench/${projectId}`
    }

    if (workId) {
      return `/workbench/${projectId}/works/${workId}/contexts/${contextId}`
    }

    return `/workbench/${projectId}/contexts/${contextId}`
  }

  const { projectId, workId, contextId } = inputOrProjectId

  if (!contextId) {
    return `/workbench/${projectId}`
  }

  if (workId) {
    return `/workbench/${projectId}/works/${workId}/contexts/${contextId}`
  }

  return `/workbench/${projectId}/contexts/${contextId}`
}

export const buildWorkbenchLedgerPath = ({
  projectId,
  workId,
  contextId,
}: BuildWorkbenchLedgerPathInput): string => (
  `${buildWorkbenchPath({ projectId, workId, contextId })}/ledger`
)

export const parseWorkbenchPath = (pathname: string): ParsedWorkbenchPathRoute | null => {
  const segments = (pathname || '').split('/').filter(Boolean)

  if (segments.length === 1 && segments[0] === 'workbench') {
    return {
      scope: 'root',
      view: 'workspace',
      projectId: '',
      workId: '',
      contextId: ''
    }
  }

  if (segments.length === 2 && segments[0] === 'workbench') {
    return {
      scope: 'project',
      view: 'workspace',
      projectId: segments[1],
      workId: '',
      contextId: ''
    }
  }

  if (segments.length === 6 && segments[0] === 'workbench' && segments[2] === 'works' && segments[4] === 'contexts') {
    return {
      scope: 'context',
      view: 'workspace',
      projectId: segments[1],
      workId: segments[3],
      contextId: segments[5]
    }
  }

  if (segments.length === 7 && segments[0] === 'workbench' && segments[2] === 'works' && segments[4] === 'contexts' && segments[6] === 'ledger') {
    return {
      scope: 'context',
      view: 'ledger',
      projectId: segments[1],
      workId: segments[3],
      contextId: segments[5]
    }
  }

  if (segments.length === 4 && segments[0] === 'workbench' && segments[2] === 'contexts') {
    return {
      scope: 'context',
      view: 'workspace',
      projectId: segments[1],
      workId: '',
      contextId: segments[3]
    }
  }

  if (segments.length === 5 && segments[0] === 'workbench' && segments[2] === 'contexts' && segments[4] === 'ledger') {
    return {
      scope: 'context',
      view: 'ledger',
      projectId: segments[1],
      workId: '',
      contextId: segments[3]
    }
  }

  return null
}
